import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "statusColor", standalone:true })
export default class StatusColorPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case "new":
        return "warning";
      case "approved":
        return "warning";
      case "refunded":
        return "success";
      case "rejected":
        return "error";
      default:
        return "warning";
    }
  }
}
